import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from './HomePage.module.scss';
import SendMessage from '../../assets/send-fill.svg';
import Delete from '../../assets/delete.svg';
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { clearSelectedMessage, closeBar, isSendMessage } from "../../store/slices/appSlice";
import { messagesAPI } from "../../API/api";
import Preloader from '../../assets/preloader.svg';
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import pLimit from "p-limit";
import { firebasePath } from "../../constants/constants";
const CONCURRENCY_LIMIT = 3;
const limit = pLimit(CONCURRENCY_LIMIT);
const BlockControl = () => {
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState(false);
    const dispatch = useAppDispatch();
    const { t } = useTypedTranslation();
    const selectedMessage = useAppSelector(state => state.app.selectedMessages);
    const chat = useAppSelector(state => state.app.selectedChat);
    const isFavorites = useAppSelector(state => state.app.isFavorites);
    const handleClickSendMessages = () => {
        if (selectedMessage.length && !error) {
            dispatch(isSendMessage(true));
            dispatch(closeBar(firebasePath.CONTACTS));
            console.log('send');
        }
    };
    const handleClickDeleteMessages = () => {
        if (!selectedMessage.length)
            return;
        setDeleting(true);
        const limitedPromises = selectedMessage.map(message => limit(() => messagesAPI.deleteMessage({ chat, message, isFavorites })));
        Promise.all(limitedPromises)
            .then(() => dispatch(clearSelectedMessage()))
            .catch(() => console.log('error deleting selected messages'))
            .finally(() => setDeleting(false));
    };
    const canselSelected = () => {
        dispatch(clearSelectedMessage());
    };
    useEffect(() => {
        const isError = selectedMessage.some(item => Boolean(item === null || item === void 0 ? void 0 : item.callStatus));
        if (isError)
            setError(true);
        if (!isError && error)
            setError(false);
    }, [selectedMessage]);
    return (_jsxs("div", { className: styles.blockControl, children: [_jsx("div", { className: styles.blockControl__item, children: _jsx("button", { onClick: canselSelected, children: t('cancel') }) }), _jsx("div", { className: styles.blockControl__item, onClick: handleClickSendMessages, title: t("forward"), children: _jsx(SendMessage, { cursor: 'pointer', fontSize: '1.4rem', color: error ? 'hsla(0, 73.92%, 60.75%, 0.75)' : undefined }) }), _jsx("div", { className: styles.blockControl__item, onClick: handleClickDeleteMessages, title: t('deleteSelected'), children: !deleting ?
                    _jsx(Delete, { cursor: 'pointer', fontSize: '1.4rem' })
                    :
                        _jsx(Preloader, { fontSize: '1.4rem' }) }), _jsx("div", { className: styles.blockControl__item, children: _jsx("span", { children: selectedMessage.length }) })] }));
};
export default BlockControl;
